module.exports = __webpack_public_path__ + "front/img/p2.617dc585.jpg";